<template>
    <div class="notification-item" :class="{ 'read': notification.read_at }" @click="handleClick">
        <div class="notification-icon-container">
            <div class="notification-type-icon" :class="notification.type">
                <!-- Icône selon le type -->
                <template v-if="notification.type === 'new_sale'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <path d="M16 10a4 4 0 0 1-8 0"></path>
                    </svg>
                </template>
                <template v-else-if="notification.type === 'low_stock'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                        <line x1="9" y1="9" x2="9.01" y2="9"></line>
                        <line x1="15" y1="9" x2="15.01" y2="9"></line>
                    </svg>
                </template>
                <template v-else-if="notification.type === 'payment_received'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2" y="5" width="20" height="14" rx="2"></rect>
                        <line x1="2" y1="10" x2="22" y2="10"></line>
                    </svg>
                </template>
                <template v-else-if="notification.type === 'refund'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="17 1 21 5 17 9"></polyline>
                        <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                        <polyline points="7 23 3 19 7 15"></polyline>
                        <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                    </svg>
                </template>
                <template v-else-if="notification.type === 'new_customer'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </template>
                <template v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </template>
            </div>
        </div>

        <div class="notification-content">
            <div class="notification-message">{{ notification.message }}</div>
            <div class="notification-time">{{ formatDate(notification.created_at) }}</div>
        </div>

        <button v-if="showActions" class="notification-action" @click.stop="markAsRead">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 11 12 14 22 4"></polyline>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'NotificationItem',
    props: {
        notification: {
            type: Object,
            required: true
        },
        showActions: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';

            const date = new Date(dateString);
            const now = new Date();
            const diffMs = now - date;
            const diffMins = Math.round(diffMs / 60000);
            const diffHours = Math.round(diffMs / 3600000);
            const diffDays = Math.round(diffMs / 86400000);

            // Moins d'une heure
            if (diffMins < 60) {
                return `Il y a ${diffMins} minute${diffMins > 1 ? 's' : ''}`;
            }

            // Moins d'un jour
            if (diffHours < 24) {
                return `Il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
            }

            // Moins d'une semaine
            if (diffDays < 7) {
                return `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
            }

            // Format standard pour les dates plus anciennes
            return date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        },
        handleClick() {
            if (!this.notification.read_at) {
                this.markAsRead();
            }
            this.$emit('click', this.notification);
        },
        markAsRead() {
            if (!this.notification.read_at) {
                this.$emit('mark-as-read', this.notification);
            }
        }
    }
}
</script>

<style scoped>
.notification-item {
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    transition: background-color 0.2s;
    position: relative;
}

.notification-item:last-child {
    border-bottom: none;
}

.notification-item:hover {
    background-color: #f9f9f9;
}

.notification-item.read {
    opacity: 0.7;
    background-color: #f5f5f5;
}

.notification-icon-container {
    margin-right: 12px;
    margin-top: 2px;
}

.notification-type-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e3f2fd;
    color: #1976d2;
}

.notification-type-icon.new_sale {
    background-color: #e8f5e9;
    color: #0A5C6B;
}

.notification-type-icon.low_stock {
    background-color: #fff8e1;
    color: #ffa000;
}

.notification-type-icon.payment_received {
    background-color: #e0f7fa;
    color: #00acc1;
}

.notification-type-icon.refund {
    background-color: #ffebee;
    color: #e53935;
}

.notification-type-icon.new_customer {
    background-color: #f3e5f5;
    color: #8e24aa;
}

.notification-content {
    flex: 1;
}

.notification-message {
    font-size: 0.85rem;
    color: #2c3e50;
    margin-bottom: 4px;
    line-height: 1.3;
}

.notification-time {
    font-size: 0.75rem;
    color: #666;
    margin-bottom: 4px;
}

.notification-action {
    background: none;
    border: none;
    color: #0A5C6B;
    padding: 4px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    transition: opacity 0.2s ease, background-color 0.2s ease;
}

.notification-item:hover .notification-action {
    opacity: 1;
}

.notification-action:hover {
    background-color: rgba(10, 92, 107, 0.1);
}

.notification-item.read .notification-action {
    display: none;
}
</style>